import { postApi } from "./api_instance";

export const taxationAmount = async (formData, dispatch) => {
  try {
    // console.log("FormData", formData);
    return await postApi({
      apiUrl: "/projects/api/taxation",
      dispatch,
      data: formData,
      sendToken: true
    });
  } catch (error) {
    throw error;
  }
};
